import MOCK from "assets/mock.png";
const Sidebar = () => {
  return <img className="w-full" src={MOCK}></img>;
};
export { Sidebar };
